import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "card border-white clinician-employees",
  id: "Clinician__Patients"
}
const _hoisted_2 = { class: "d-flex align-items-center py-2 px-3 bg-primary text-white font-size-md fw-bold" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " Employee ", -1 /* HOISTED */)
const _hoisted_4 = { class: "d-flex p-2" }
const _hoisted_5 = { class: "input-group-append ms-2" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "patient employee-card" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_9 = { class: "d-flex align-items-center font-size-md" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "d-flex justify-content-between mb-1" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Status : ")
const _hoisted_13 = { class: "text-default" }
const _hoisted_14 = {
  key: 0,
  class: "mt-1 mb-1"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = {
  key: 0,
  class: "d-flex align-items-center me-4"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-mobile text-primary me-1" }, null, -1 /* HOISTED */)
const _hoisted_23 = ["href"]
const _hoisted_24 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-birthday-cake text-primary me-1" }, null, -1 /* HOISTED */)
const _hoisted_26 = {
  key: 1,
  class: "d-flex flex-column w-100 align-items-center text-center py-5 px-3 text-primary"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search fa-5x mb-4" }, null, -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 2,
  class: "d-flex flex-column w-100 align-items-center text-center py-5 px-3 text-primary"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search fa-5x mb-4" }, null, -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "font-size-lg" }, " Searching.... ", -1 /* HOISTED */)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = {
  key: 3,
  class: "error-state"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("There was a problem while fetching employees."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Please try again.")
], -1 /* HOISTED */)
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 4,
  class: "no-data"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", null, "No employees found.", -1 /* HOISTED */)
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductPill = _resolveComponent("ProductPill")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("i", {
        class: "ms-auto fas fa-times",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeEmployees()))
      })
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          autofocus: "",
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
          placeholder: "Search by Employee Name"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.searchQuery]
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "submit",
            disabled: _ctx.disableForm(),
            class: "btn btn-primary"
          }, "Search", 8 /* PROPS */, _hoisted_6)
        ])
      ])
    ], 32 /* HYDRATE_EVENTS */),
    _createElementVNode("section", {
      class: _normalizeClass(["d-flex flex-column overflow-auto flex-nowrap w-100 h-100 scroll-paginate", `${_ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`])
    }, [
      (_ctx.employeeList.length && !_ctx.hasError)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.employeeList, (employee) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("b", null, _toDisplayString(employee.lastName) + ", " + _toDisplayString(employee.firstName), 1 /* TEXT */)
                ]),
                _createElementVNode("span", null, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (_ctx.handleNavigation(employee)),
                    class: "align-self-start",
                    href: "javascript:void(0);"
                  }, " View Chart ", 8 /* PROPS */, _hoisted_10)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_ProductPill, {
                  class: "application-name",
                  "product-id": _ctx.getApplicationId(employee.application)
                }, null, 8 /* PROPS */, ["product-id"]),
                (employee.status)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: _normalizeClass('fw-bold mb-0 status-label ' + _ctx.getStatusText(employee.status).toLowerCase())
                    }, [
                      _hoisted_12,
                      _createElementVNode("span", null, _toDisplayString(_ctx.getStatusText(employee.status)), 1 /* TEXT */)
                    ], 2 /* CLASS */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_13, _toDisplayString(employee.organization), 1 /* TEXT */),
              (employee.address)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (employee.address.addressLine1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(employee.address.addressLine1), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (employee.address.addressLine2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, ", " + _toDisplayString(employee.address.addressLine2), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (employee.address.city)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, ", " + _toDisplayString(employee.address.city), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (employee.address.state)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, ", " + _toDisplayString(employee.address.state), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (employee.address.zipCode)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, ", " + _toDisplayString(employee.address.zipCode), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_20, [
                (employee.phone)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("a", {
                        href: 'tel:' + employee.phone
                      }, _toDisplayString(_ctx.formatPhone(employee.phone)), 9 /* TEXT, PROPS */, _hoisted_23)
                    ]))
                  : _createCommentVNode("v-if", true),
                (employee.birthday)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(employee.birthday, "MMM DD, YYYY")), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" WAITING "),
      (_ctx.isLoading == null && !_ctx.hasError)
        ? (_openBlock(), _createElementBlock("p", _hoisted_26, _hoisted_28))
        : _createCommentVNode("v-if", true),
      (_ctx.isLoading && !_ctx.hasError)
        ? (_openBlock(), _createElementBlock("p", _hoisted_29, _hoisted_32))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" ERROR "),
      (_ctx.hasError && !_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("button", {
              disabled: _ctx.disableForm(),
              class: "btn btn-primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchEmployee()))
            }, "Try Again", 8 /* PROPS */, _hoisted_35)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" NO DATA "),
      (_ctx.employeeList.length === 0 && _ctx.isLoading == false && !_ctx.hasError)
        ? (_openBlock(), _createElementBlock("p", _hoisted_36, _hoisted_38))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ]))
}